import { render, staticRenderFns } from "./CertifiedLogos.vue?vue&type=template&id=a173824c&scoped=true&"
import script from "./CertifiedLogos.vue?vue&type=script&lang=js&"
export * from "./CertifiedLogos.vue?vue&type=script&lang=js&"
import style0 from "./CertifiedLogos.vue?vue&type=style&index=0&id=a173824c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a173824c",
  null
  
)

export default component.exports